const DeviceType = {
  Desktop: 'desktop',
  Mobile: 'mobile',
};

export default DeviceType;
